<template>
  <div v-if="isShow">
    <div class="bg_white mt12 pt16 pb16 boxs1">
      <h2 class="content_title">スケジュール選択</h2>

      <div class="schedule_list">
        <div class="schedule_contents">
          <label @click="changeCalendarType(value.calendarTypeId)" v-for="(value, index) in typeList" :for="'radio' + value.calendarTypeId" class="schedule_btn ar" :class="{ 'select': selectType == value.calendarTypeId  }">{{ value.calendarName }}<input class="radio" :id="'radio' + value.calendarTypeId" type="radio" name="selectType" :value="value.calendarTypeId" :key="index"></label>
        </div>
      </div>
    </div>

    <div class="mt12 boxs1">
      <Calendar :checkDate="sendDay" />
    </div>

    <div class="schedule bg_white mt12 pt10 pb16">
      <router-link class="schedule_item" v-for="(value, n) in dayList" :to="{ name: 'salonScheduleDetail', query: {id: value.calendarId} }" :key="n">
        <h2 class="schedule_title c5a ab" :style="{'border-left': '5px solid ' + value.color}">{{ value.title }}</h2>
        <div class="detail_wrap c5a">
          <p class="schedule_detail rb">{{ value.scheduleDateTime }}</p>
        </div>
      </router-link>
    </div>
  </div>
  <div v-else class="bg_white pt16 pb16 pl16 pr16 ab">アクセスエラー<br>coNPusアプリから再度開き直してください。</div>
</template>

<script>
import moment from 'moment';
import Calendar from '@/components/salon/Calendar';
import Check from '@/model/getToken'
import CalendarApi from '@/components/api/calendar'
import { mapGetters } from 'vuex';

const today = new Date();

export default {
  components: {
    Calendar,
  },
  data() {
    return {
      typeList: [],
      isShow: true,
      sendDay: [],
      dayList: [],
    }
  },
  methods: {
    changeCalendarType(calendarTypeId) {
      this.$store.commit('salon/setSelectType', calendarTypeId);
      this.$store.commit('salon/setSelectDay', null);

    },
    async apiGetTypeList() {
      await CalendarApi.getCalendarTypeList().then((val) => {
        this.typeList.splice(0, this.typeList.length);
        this.typeList.push(...val);
      });
    },
    setCalendarType() {
      let typeId = this.typeList[0].calendarTypeId;

      let calendarPattern = this.$route.query.calendarPattern;
      if(calendarPattern) {
        let findPattern = this.typeList.find((v) => v.calendarPattern ==  this.$route.query.calendarPattern);
        typeId = findPattern.calendarTypeId;
      }

      if(this.selectType != null) {
        typeId = this.selectType;
      }

      this.$store.commit('salon/setSelectType', typeId);
    },
    async apiGetCalendarMonthList() {
      await CalendarApi.getCalendarMonthList(this.selectType, this.currentDate.format('Y-MM')).then((val) => {
        this.sendDay.splice(0, this.sendDay.length);
        for (var i = 0; i < val.length; i++) {
          let data = {
            day: val[i].targetDate,
            color: val[i].calendarScheduleList[0].color,
          }
          this.sendDay.push(data);
        }
      });
    },
    async apiGetCalendarDayList(selectType, selectYmd) {
      await CalendarApi.getCalendarDayList(selectType, selectYmd).then((val) => {
        this.dayList.splice(0, this.dayList.length);
        this.dayList.push(...val);
      });
    },
    initializedSalonInfo() {
      if(this.selectType != null && this.selectDay != null) {
        // 表示している月のセミナー情報を取得
        this.apiGetCalendarMonthList();
        // 選択している日のセミナー情報を取得
        this.apiGetCalendarDayList(this.selectType, moment(this.selectDay).format('Y-MM-DD'));
      }
    },
    initialized() {
      this.typeList.splice(0, this.typeList.length);
      this.sendDay.splice(0, this.sendDay.length);
      this.dayList.splice(0, this.dayList.length);
    },
  },
  computed: mapGetters(
    'salon', ['selectType', 'selectDay', 'currentDate'],
  ),
  async created() {
    let res;
    await Check.checkRequest(this.$route.query.code).then((val) => { res = val; });
    if(res) {
      // データ初期化
      this.initialized();
      // スケジュールのタイプを取得
      await this.apiGetTypeList();
      // 現在のタイプを選択
      this.setCalendarType();

      this.initializedSalonInfo();
    } else {
      this.isShow = false;
    }
  },
  watch: {
    selectType() {
      this.initializedSalonInfo();
    },
    selectDay() {
      this.initializedSalonInfo();
    },
    currentDate() {
      this.initializedSalonInfo();
    }
  }
}
</script>

<style lang="css" scoped>
.content_title {
  width: 218px;
}
.schedule_list {
  margin-top: 16px;
}
.schedule_contents {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  padding: 0 10px;
  width: 100%;
}
.schedule_btn {
  background-color: #fff;
  border: 1px solid #636366;
  border-radius: 50px;
  color: #636366;
  font-size: 12px;
  line-height: 1;
  padding: 10px 0;
  text-align: center;
}
.select {
  background-color: #00FFFF;
  border: 1px solid #0E9AFF;
  color: #0E9AFF;
}

.schedule {
  padding-bottom: 48px;
}

.schedule_item {
  border-bottom: 1px solid  #bfbfbf;
  display: block;
  padding-top: 10px;
  padding-left: 32px;
  padding-bottom: 12px;
}

.schedule_item:not(:first-child) {
  margin-top: 34px;
  padding-top: 0;
}

.schedule_title {
  font-size: 13px;
  border-left: 5px solid  #4FCCD4;
  padding-left: 5px;
}

.schedule_detail {
  font-size: 14px;
}
.year, .month, .day, .day_of_week {
  font-size: 10px;
}
.day_of_week {
  margin: 0 4px;
}

.detail_wrap {
  margin-top: 12px;
  position: relative;
  padding-right: 30px;
}

.detail_wrap::after {
  content: '\f054';
  color: #636366;
  font-size: 12.8px;
  font-family: "Font Awesome 5 Free","Font Awesome 5 Brands";
  font-weight: 900;
  position: absolute;
  right: 22px;
  top: 50%;
  transform: translateY(-50%);
}

.detail_teacher {
  font-size: 12px;
}
.radio {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/views/salon/Schedule.vue